import type { DemandBatch } from '@/services/demand'

export type DemandListKpis = {
  batches: number
  lineCountSum: number
}

export function computeDemandListKpis(rows: DemandBatch[]): DemandListKpis {
  let lineCountSum = 0
  for (const r of rows) {
    lineCountSum += r.line_count ?? 0
  }
  return { batches: rows.length, lineCountSum }
}
